module.exports = __webpack_public_path__ + "img/1440.30439f09.jpg";